import React, { useState } from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import ButtonTag from '@components/framework/tags/ButtonTag.tsx';
import { SecuredConfig } from '@components/security/securedDecoration';
import RingilTextArea from '@components/framework/input/RingilTextArea.tsx';
import { Field } from '@components/framework/formfield/Field.tsx';
import { ValidationError } from 'yup';
import { hasValidationProblemForPrefix } from '@utils/validation.tsx';
import SvgNumber from '@icons/Number.tsx';

interface ComponentProps {
  secured?: SecuredConfig;
  value: string;
  onChange: (value: string) => void;
  readonly?: boolean;
  validationErrors?: ValidationError[];
  validationPrefix?: string;
}

const InternalInfoPairingSymbol: React.FC<ComponentProps> = ({ secured, value, onChange, readonly, validationErrors, validationPrefix }) => {
  const [internalValue, setInternalValue] = useState<string>(value);
  const { tr } = useTranslationLgs();

  const printValue = (value: string) => {
    return value;
  };

  return (
    <>
      <ButtonTag secured={secured}
        label={tr("InternalInfoPairingSymbol.parovaciSymbol", "Párovací symbol")}
        icon={<SvgNumber />}
        required={false}
        value={printValue(value)}
        readonly={readonly}
        onSave={(onSuccess) => {
          onChange(internalValue);
          onSuccess();
        }}
        popupWidth={'350px'}
        autoClose
        dataTestId="internalInfo-pairingSymbol"
      >
        <>
          <Field label={tr("InternalInfoPairingSymbol.parovaciSymbol", "Párovací symbol")}>
            <RingilTextArea
              value={internalValue}
              onChange={(v) => setInternalValue(v)}
              maxLength={255}
              rows={1}
              className={'resize-none'}
              dataTestId="internalInfo-pairingSymbolInput"
            />
          </Field>
        </>
      </ButtonTag>
    </>);

};

export default InternalInfoPairingSymbol;